import React from 'react';

import { Box, Chip } from '@mui/material';

import { ServiceTypes } from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';

import strings from '../../../localization';

import classes from './styles';

interface ICrossPlatformStatusProps {
  portedToPP: boolean;
  portedFromPG: boolean;
}

const CrossPlatformProfileStatus = ({
  portedToPP,
  portedFromPG,
}: ICrossPlatformStatusProps) => {
  const isSelfService = ServiceHandler.getService() === ServiceTypes.self;
  const existsOnOtherPlatform = isSelfService ? portedToPP : portedFromPG;

  if (!existsOnOtherPlatform) {
    return null;
  }

  const counterpartLabel = isSelfService
    ? strings.alsoExistsOnPP
    : strings.alsoExistsOnPG;

  return (
    <Box sx={classes.container}>
      <Chip label={counterpartLabel} sx={classes.counterpartChip} />
    </Box>
  );
};

export default CrossPlatformProfileStatus;
